import { Redirect } from 'raviger';
import React from 'react';

import { createSignInWithRedirectAfterUrl } from '../../core/authentication/redirect';

const RedirectToSignIn = ({ redirectAfter = null }) => (
  <Redirect to={createSignInWithRedirectAfterUrl(redirectAfter)} />
);

export default RedirectToSignIn;